<template>
    <form class="form-inline">
        <b-input-group>
            <b-form-input                
                v-model="value"
                :disabled="disabled"
                type="text"
                placeholder="YYYY-MM-DD"
                autocomplete="off"
            ></b-form-input>
            <b-input-group-append>
                <b-form-datepicker
                v-model="value"
                button-only
                :disabled="disabled"
                right
                locale="en-US"                              
                ></b-form-datepicker>
            </b-input-group-append>
        </b-input-group>        
    </form>
</template>
<script>
    // :target-offset="300"
    //import UtcDatepicker from './datepicker/UtcDatePicker';
    export default {
        // components: {
        //     UtcDatepicker
        // },
        computed: {
            internalV:{
                get(){
                    return this.value;
                },
                set(v){
                    if (this.valid)
                        this.$emit('input', v);
                    else
                        this.$emit('input','');
                }
            },
            valid: {
                get(){
                    let regex = /^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/;
                    return !this.value || !!this.value.match(regex);
                }
            }
        },
        props: {
            value: {
                required: true, type: String
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    }
</script>
<style>
    .datepicker-field{
        width: 12em;
    }
</style>